import { shouldShowBizChatInReadingPane } from '../selectors/shouldShowBizChatInReadingPane';
import { setShowBizChatInReadingPaneMutator } from '../mutators/setShowBizChatInReadingPaneMutator';
import { closeBizChatInReadingPaneAndSetWidthMutator } from '../mutators/closeBizChatInReadingPaneAndSetWidthMutator';
import { onCopilotChatDrawerLayoutChange } from '../actions/onCopilotChatDrawerLayoutChange';
import { MINIMUM_COPILOT_CHAT_DRAWER_WIDTH } from './copilotChatDrawerConstants';

/**
 * Undocks BizChat from the reading pane area. When `shouldCollapseDrawer` is true,
 * also snaps the drawer to its minimum width so a freshly-opened message has room.
 */
export const closeBizChatInReadingPane = (
    targetWindow: Window,
    shouldCollapseDrawer: boolean = false
): void => {
    if (shouldShowBizChatInReadingPane(targetWindow)) {
        if (shouldCollapseDrawer) {
            closeBizChatInReadingPaneAndSetWidthMutator(
                targetWindow,
                MINIMUM_COPILOT_CHAT_DRAWER_WIDTH
            );
        } else {
            setShowBizChatInReadingPaneMutator(targetWindow, false);
        }
        onCopilotChatDrawerLayoutChange();
    }
};
